<app-comment-panel referenceType="DOCUMENT" [referenceId]="document.id" [referenceName]="document.name">
  @if (hasNotification) {
    <span class="update-notification" matTooltip="New update"></span>
  }
  <div
    class="doc-card"
    (click)="openInNewTab($event)"
    [class.job-package]="document.documentType === 'JOB_PACKAGE'"
    [class.model-3d]="is3dModel"
    [class.video-doc]="isVideoModel"
  >
    <div class="doc-card__thumb" [style.background-image]="thumbnailImage">
      <span
        class="doc-card__badge"
        [class.doc-card__badge--package]="document.documentType === 'JOB_PACKAGE'"
        [class.doc-card__badge--attachment]="document.documentType === 'ATTACHMENT'"
        [class.doc-card__badge--3d]="is3dModel"
        [class.doc-card__badge--video]="isVideoModel"
        [class.doc-card__badge--time]="isTimeDrawing"
      >
        @if (document.documentType === 'JOB_PACKAGE') {
          <mat-icon class="doc-card__badge-icon">inventory_2</mat-icon>
          {{ 'workOrderDocuments.jobPackage' | translate }}
        } @else if (is3dModel) {
          <mat-icon class="doc-card__badge-icon">view_in_ar</mat-icon>
          3D Model
        } @else if (isVideoModel) {
          <mat-icon class="doc-card__badge-icon">movie</mat-icon>
          {{ 'workOrderDocuments.video' | translate }}
        } @else if (isTimeDrawing) {
          <mat-icon class="doc-card__badge-icon">architecture</mat-icon>
          {{ 'workOrderDocuments.timeDrawing' | translate }}
        } @else {
          <mat-icon class="doc-card__badge-icon">description</mat-icon>
          {{ 'workOrderDocuments.attachment' | translate }}
        }
      </span>
      @if (document.revisionTime) {
        <span class="doc-card__thumb-time">
          <mat-icon class="doc-card__meta-icon">schedule</mat-icon>
          {{ document.revisionTime | dwoDateTime }}
        </span>
      }
    </div>
    <div class="doc-card__body">
      @if (isTimeDrawing) {
        <p class="doc-card__title" [title]="document.documentNumber || document.name">
          {{ document.documentNumber || document.name }}
        </p>
        @if (document.documentNumber && document.name) {
          <p class="doc-card__filename doc-card__filename--multiline" [title]="document.name">{{ document.name }}</p>
        }
      } @else if (document.name) {
        <p class="doc-card__title" [title]="document.name">{{ document.name }}</p>
      }
      @if (document.documentType === 'JOB_PACKAGE') {
        <p class="doc-card__filename" [title]="document.filename || document.documentNumber">
          {{ document.filename || document.documentNumber }}
        </p>
      }
      @if (document.documentType === 'JOB_PACKAGE' && document.revisionNumber) {
        <p class="doc-card__meta">
          <mat-icon class="doc-card__meta-icon">published_with_changes</mat-icon>
          {{ 'workOrderDocuments.revision' | translate }}: {{ document.revisionNumber }}
        </p>
      }
      @if (showStatus) {
        <span
          class="doc-card__status"
          [class.doc-card__status--readonly]="isStatusReadOnly"
          [class.doc-card__status--redline]="document.documentProcessStatus?.id === 1"
          [class.doc-card__status--nochange]="document.documentProcessStatus?.id === 9"
          (click)="openStatusDialog($event)"
        >
          @if (statusLabelParams) {
            {{ statusLabelKey | translate: statusLabelParams }}
          } @else {
            {{ statusNotSetLabelKey | translate }}
          }
        </span>
      }
    </div>
  </div>
  @if (!is3dModel && !isVideoModel && enableRedlineMarkup) {
    <button mat-icon-button class="doc-card__preview-btn" (click)="openMarkup($event)" matTooltip="Edit document">
      <mat-icon>edit_document</mat-icon>
    </button>
  }
</app-comment-panel>
